import React from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import TravelTime from "../../steps/Step1/atoms/TravelTime";
import NoImg from "../../assets/img/no-img.svg";
import useStyles from "./styles";

const AccomodationCard = ({ accomodationInfo }) => {
  const classes = useStyles();
  const theme = useTheme();
  const show = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <Grid item xs={12} className={classes.hotelCardStyles}>
      {show && (
        <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
          <Box>
            <Typography variant="h4">Hotel Details</Typography>
          </Box>
        </Box>
      )}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h4">
            <b>{`${accomodationInfo?.type} in ${accomodationInfo?.location?.city}`}</b>
          </Typography>
        </Box>
        <TravelTime
          label="Length of stay:"
          value={`${accomodationInfo.nights} nights`}
        />
      </Box>
      <Box
        className={classes.accomodationImg}
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={2.5}
        mb={2.5}
      >
        {!accomodationInfo.img ? (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box mb={1.5}>
              <img src={NoImg} alt="no-img" />
            </Box>
            <Typography color="textSecondary" variant="subtitle1">
              <b>IMAGE NOT AVAILABLE</b>
            </Typography>
          </Box>
        ) : (
          <div
            className={classes.img}
            style={{
              backgroundImage: `url(${accomodationInfo.img})`,
            }}
          ></div>
        )}
      </Box>
      <Box display="flex" flexDirection={{ xs: "column", sm: "row" }}>
        <DescriptionBlock
          label="Location"
          value={`${accomodationInfo?.location?.address}, ${accomodationInfo?.location?.city}, ${accomodationInfo?.location?.country}, ${accomodationInfo?.location?.postalCode}`}
        />
        <DescriptionBlock label="CHECK IN" value={accomodationInfo.checkIn} />
        <DescriptionBlock label="CHECK OUT" value={accomodationInfo.checkOut} />
        <DescriptionBlock label="Guests" value={accomodationInfo.guests} />
        <DescriptionBlock label="Rooms" value={accomodationInfo.rooms} />
      </Box>
    </Grid>
  );
};

const DescriptionBlock = ({ label, value }) => {
  const classes = useStyles();
  return (
    <Box className={classes.accomodationDescription}>
      <Box>
        <Typography className={classes.label} color="textSecondary">
          {label}
        </Typography>
      </Box>
      <Box>
        <Typography>{value}</Typography>
      </Box>
    </Box>
  );
};

export default AccomodationCard;
